import { Flex } from "@simplybusiness/mobius";
import { StyledSkeleton } from ".";

export const CardSkeleton = () => (
  <li className="mobius-quote-card">
    {/* <Header /> */}
    <Flex className="mobius-quote-card__header" flexDirection="column">
      <StyledSkeleton
        className="mobius-quote-card__header-logo"
        height="40px"
      />
      <Flex className="mobius-quote-card__ratings --has-reinsurer-text">
        <StyledSkeleton />
        <StyledSkeleton />
      </Flex>
    </Flex>
    {/* <Pricing /> */}
    <div className="mobius-quote-card__pricing">
      <StyledSkeleton width="70%" height="30px" />
      <StyledSkeleton width="40%" />
      <StyledSkeleton style={{ marginBottom: "10px" }} />
      <div className="mobius-quote-card__badges">
        <div style={{ width: "100%" }}>
          <StyledSkeleton height="34px" />
        </div>
      </div>
    </div>
    {/* <Coverage /> */}
    <Flex
      flexDirection="column"
      gap="sm"
      className="mobius-quote-card__coverage"
    >
      <StyledSkeleton width="56%" />
      <StyledSkeleton width="45%" />
      <StyledSkeleton />
      <StyledSkeleton />
      <StyledSkeleton width="50%" />
    </Flex>
    {/* <QuoteActions /> */}
    <Flex
      justifyContent="space-between"
      gap="sm"
      className="mobius-quote-actions"
    >
      <div className="mobius-quote-actions__button qa-view-details-option">
        <StyledSkeleton height="40px" />
      </div>
      <div className="mobius-quote-actions__button qa-buy-quote-option">
        <StyledSkeleton height="40px" />
      </div>
    </Flex>
  </li>
);
